import { NavLink } from 'react-router-dom'

const TABS = [
  { label: 'Users',            to: '/admin/users' },
  { label: 'Teams',            to: '/admin/teams' },
  { label: 'AI Tools',         to: '/admin/tools' },
  { label: 'AI Models',        to: '/admin/models' },
  { label: 'Product Lifecycle', to: '/admin/product-lifecycles' },
  { label: 'Survey Questions', to: '/admin/questions' },
]

export default function AdminTabs() {
  return (
    <nav className="admin-tabs" aria-label="Admin sections">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) => `admin-tab${isActive ? ' active' : ''}`}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  )
}
